import _ from 'lodash'
import isPercentDisplayed from 'scoreboard/components/is-percent-displayed'
import moveDecimal from 'scoreboard/components/move-decimal'


/**
 * 	Formats a value for fields with dataType PERCENT to display as the user
 * 	entered it.
 *  (ex. When used with the render-values-select, this allows typing in "33"
 *  to display as "+ Add 33%" instead of "+ Add 3300%")
 * @param dataType
 * @param value
 * @returns {string|Number|string|*}
 */
function convertPercentValuesForValuesSelect(dataType, value) {
	if (isPercentDisplayed(dataType)) {
		// strip any unwanted symbols
		if (value && typeof value === 'string') {
			value = value.replace(/%$/, '')
		}
		// only try to moveDecimal if we have a numeric value
		if (value && !_.isNaN(_.toNumber(value))) {
			return moveDecimal(value, -2)
		}
	}
	return value
}

export { convertPercentValuesForValuesSelect }